import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { FuseConfigService } from "@fuse/services/config.service";
import { FuseSplashScreenService } from "@fuse/services/splash-screen.service";
import { TRANSLOCO_SCOPE, TranslocoService } from "@ngneat/transloco";

@Component({
  selector: "app-erreur-internet",
  templateUrl: "./erreur-internet.component.html",
  styleUrls: ["./erreur-internet.component.scss"],
  standalone: false,
  providers: [{
    provide : TRANSLOCO_SCOPE,
    useValue:{ scope:'popups', alias: 'popups' }
  }]
})
export class ErreurInternetComponent implements OnInit, OnDestroy {

  constructor(
    private splashScreen: FuseSplashScreenService,
    private _fuseConfigService: FuseConfigService, private router: Router,
    private transloco: TranslocoService,
  ) {
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        toolbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        sidepanel: {
          hidden: true,
        },
      },
    };
  }

  blink = true;

  public ngOnInit(): void {
    this.splashScreen.hide();
  }

  public ngOnDestroy(): void {}

  get offlineTitle(): string {
    const lang = this.transloco.getActiveLang();
    return lang === 'ar' ? 'لا يوجد اتصال بالإنترنت' :
      lang === 'en' ? 'No internet connection' :
      lang === 'tr' ? 'İnternet bağlantısı yok' : 'Pas de connexion Internet';
  }

  get reloadPageLabel(): string {
    const lang = this.transloco.getActiveLang();
    return lang === 'ar' ? 'إعادة تحميل الصفحة' :
      lang === 'en' ? 'Reload page' :
      lang === 'tr' ? 'Sayfayı yenile' : 'Recharger la page';
  }

  public recharge(): void {
    window.location.reload();
  }

}
